import { render, staticRenderFns } from "./Win.vue?vue&type=template&id=f61c5048&scoped=true"
import script from "./Win.vue?vue&type=script&lang=js"
export * from "./Win.vue?vue&type=script&lang=js"
import style0 from "./Win.vue?vue&type=style&index=0&id=f61c5048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61c5048",
  null
  
)

export default component.exports